module.exports = __webpack_public_path__ + "static/media/js-brands.3094c423.svg";